module.exports = "/_next/static/images/68f5e071d6884580133202e613cf9ddd-nubanker-pm@1x.jpg";